import request from '@/utils/request'

export interface IWalletTx {
  id: number
  userId: number
  userName?: string
  userPhone?: string
  type: number
  amount: number
  payMethod: number
  relatedOrderId?: number
  status: number
  createTime?: string
  updateTime?: string
}

export function getWalletTxPage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  type?: number
  payMethod?: number
  status?: number
  storeId?: number | string
}) {
  return request({
    url: '/wallet/transaction/page',
    method: 'get',
    params
  })
}
